import {PlayerProps} from "../screens/match/matchProps";

export const getBestMatchingPlayer = (player: PlayerProps, substitute: PlayerProps, licenceNumber = false) => {
    if (substitute && substitute.licence_number && substitute.licence_number !== "") {
        if (licenceNumber) return substitute.licence_number;
        return substitute.fullname;
    }
    if (licenceNumber) return player.licence_number || "";
    return player.fullname || "To be defined";
};